module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "toc"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fmh1"
  }, [_vm._v("\n    Table of Contents\n  ")]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_fm1_r1"
    }
  }, [_vm._v("Praise")])]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_tp_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_ded_r1"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_prf_r1"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c01_r1"
    }
  }, [_vm._v("Chapter 1 - The Stress Epidemic")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c01_r1#h1"
    }
  }, [_vm._v("How Did We Get into This Situation?")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c01_r1#h2"
    }
  }, [_vm._v("Are We Talking About You?")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c01_r1#h3"
    }
  }, [_vm._v("How to Change Course")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c01_r1#h4"
    }
  }, [_vm._v("The Theory Behind the Stress Epidemic and This Book")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c01_r1#h5"
    }
  }, [_vm._v("How This Book Works")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c01_r1#h6"
    }
  }, [_vm._v("Take-Home Messages from This Chapter")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cpt"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_p01_r1"
    }
  }, [_vm._v("PART I - DUALITY")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c02_r1"
    }
  }, [_vm._v("Chapter 2 - Hormones")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c02_r1#h1"
    }
  }, [_vm._v("Yin and Yang")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c03_r1"
    }
  }, [_vm._v("Chapter 3 - Sex Hormones")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c03_r1#h1"
    }
  }, [_vm._v("Estrogen: Yin Within Yin")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c03_r1#h2"
    }
  }, [_vm._v("Progesterone: Yang Within Yin")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c04_r1"
    }
  }, [_vm._v("Chapter 4 - Stress Hormones")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c04_r1#h1"
    }
  }, [_vm._v("Cortisol: Yang Within Yang")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c04_r1#h2"
    }
  }, [_vm._v("DHEA: Yin Within Yang")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c04_r1#h3"
    }
  }, [_vm._v("Oxytocin and Prolactin: Bonus Buffers")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c05_r1"
    }
  }, [_vm._v("Chapter 5 - Understanding How Yin and Yang Hormones Interact")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c05_r1#h1"
    }
  }, [_vm._v("Survival Always Comes First")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c05_r1#h2"
    }
  }, [_vm._v("Nature’s Good Intentions for Us")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c06_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6 - Why Not Just Take HRT/Synthetic or Bioidentical Hormones?")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c06_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Synthetic Hormones")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c06_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bioidentical Hormones")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c06_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Take-Home Messages from Part I")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cpt"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_p02_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART II - WOMEN’S HEALTH CONCERNS")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c07_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7 - Women’s Health Concerns")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c08_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8 - Feeling Crummy")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c08_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What Does Eastern Medicine Do About “Feeling Crummy”?")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c08_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What Should I Do?")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c09_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9 - Menstruation")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c09_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Why We Have Cycles")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c09_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eliminating Cycles")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c09_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What Does Eastern Medicine Do About Menstruation?")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c09_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What Should I Do?")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c10_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10 - Menstrual Difficulties")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c10_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scanty or Absent Periods")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c10_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What Does Eastern Medicine Do About Scanty or Absent Periods?")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c10_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What Should I Do?")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c10_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Heavy or Painful Periods")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c10_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What Does Eastern Medicine Do About Heavy Bleeding or Painful Periods?")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c10_r1#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What Should I Do?")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c10_r1#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Irregular or Missed Cycles")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c10_r1#h8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What Does Eastern Medicine Do About Irregular or Missed Cycles?")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c10_r1#h9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What Should I Do?")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c11_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11 - Birth Control")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c11_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Historical and Current Practices")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c11_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What Does Eastern Medicine Do About Birth Control?")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c11_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What Should I Do?")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c12_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12 - Fertility and Conception")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c12_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Egg")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c12_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Sperm")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c12_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Reproductive System")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c12_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Timing of Conception")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c12_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What Does Eastern Medicine Do About Conception?")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c12_r1#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What Should I Do?")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c13_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13 - Breast Health")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c13_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Considering the Known Risk Factors")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c13_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Synthetic Hormones and Breast Health")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c13_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What Does Eastern Medicine Do for Breast Health?")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c13_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What Should I Do?")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c14_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14 - Perimenopause and Menopause")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c14_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Perimenopause and Menopause: From Brawn to Brains")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c14_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Synthetic Hormone Replacement Therapy")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c14_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bioidentical Hormone Replacement Therapy")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c14_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What Does Eastern Medicine Do for Perimenopause and Menopause?")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c14_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What Should I Do?")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c15_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15 - Heart Health")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c15_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Women’s Heart Health vs. Men’s Heart Health")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c15_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Inflammation and Heart Health")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c15_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Diet,Walking, Stretching, and Heart Health")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c15_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Smoking and Heart Health")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c15_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Emotions and Heart Health")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c15_r1#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Synthetic Hormones and Heart Health")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c15_r1#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Alcohol and Heart Health")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c15_r1#h8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What Does Eastern Medicine Do for Heart Health?")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c15_r1#h9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What Should I Do?")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c16_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16 - Osteoporosis")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c16_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bone Quantity and Quality")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c16_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hormones and Bone Loss")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c16_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Calcium, Diet, and Exercise")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c16_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Breastfeeding")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c16_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Antidepressants")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c16_r1#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Osteoporosis Drugs")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c16_r1#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What Does Eastern Medicine Do About Osteoporosis?")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c16_r1#h8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What Should I Do?")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c17_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17 - Alzheimer’s Disease and Dementia")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c17_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What Does Eastern Medicine Do for Alzheimer’s and Dementia?")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c17_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What Should I Do?")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cpt"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_p03_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART III - USING THE THREE PILLARS OF HEALTH TO RESTORE HORMONAL BALANCE")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c18_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18 - The Importance of Diet and Lifestyle")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c18_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Disease Care vs. Disease Prevention")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c18_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Awareness")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c18_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Three Steps to Get Started")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c19_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19 - Quality and Quantity of Food")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c19_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Quality")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c19_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Quantity")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c20_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20 - Food, Medicine, and Poison")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c20_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ama, or Toxic Sludge")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c20_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eat in a Calm Mood and Environment")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c20_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How to Reduce Food Intolerance")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c20_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cravings and Choices")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c21_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 21 - What to Eat")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c21_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Whole Foods")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c21_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What to Eat in Times of Stress")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c22_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 22 - Meat")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c22_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Building Blood and Strength")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c22_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Belief Systems")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c22_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Other Considerations")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c23_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 23 - What Not to Eat")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c23_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fast or Highly Processed Food")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c23_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Alcohol")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c23_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cola")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c23_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Foods Treated with Pesticides and Chemicals")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c24_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 24 - The Pros and Cons of Soy")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c24_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The “Bad Soy” Camp")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c24_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The “Good Soy” Camp")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c24_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Soy: Meeting in the Middle")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c24_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What Does Eastern Medicine Say About Soy?")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c24_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Some Conclusions About Phytoestrogens")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c25_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 25 - Essential Elements of a Healthy Lifestyle")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c25_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Trapped on the Modern Treadmill")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c25_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Good News (Yes,There Is Some!)")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c25_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Relaxing into a Routine")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c25_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Exercise")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c25_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sleep")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c25_r1#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Relationships")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c25_r1#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Environment")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c26_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 26 - Stress Management Techniques")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c26_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stress and Its Causes")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c26_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("First Things First")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c26_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spiritual Practices and Meditation")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c26_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Abhyanga: Warm Oil Self-Massage")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c26_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pranayama and Alternate-Nostril Breathing")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c26_r1#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Laughter")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c27_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 27 - Changing Lifestyles, Changing Lives")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c27_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hope")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c27_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Take Away Everything That Isn’t Horse")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c27_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sacrifice Ambition at the Altar of Reality")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c27_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Surrender to the Pace of Your Body")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c27_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Making Choices")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c27_r1#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Self-Blame vs. Self-Responsibility")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c27_r1#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nature Throws Us Curve Balls")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c27_r1#h8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How Long Does It Take to See Change?")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c27_r1#h9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Three-Tier Treatment Strategy Revisited")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_c27_r1#h10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Take-Home Messages from Part III")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "apt"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_ap1_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APPENDIX A - RESOURCES")])]), _vm._v(" "), _c('div', {
    staticClass: "apt"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_ap2_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APPENDIX B - AN INTRODUCTION TO AYURVEDA AND TRADITIONAL CHINESE MEDICINE (TCM)")])]), _vm._v(" "), _c('div', {
    staticClass: "apt"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_ap3_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APPENDIX C - ABHYANGA, OR AYURVEDIC WARM-OIL MASSAGE")])]), _vm._v(" "), _c('div', {
    staticClass: "apt"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_ap4_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APPENDIX D - HOW TO MAKE KITCHERI AND GHEE")])]), _vm._v(" "), _c('div', {
    staticClass: "apt"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_ap5_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APPENDIX E - CASTOR OIL PACKS FOR UTERINE HEALTH")])]), _vm._v(" "), _c('div', {
    staticClass: "apt"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_ap6_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APPENDIX F - FOOD GLOSSARY")])]), _vm._v(" "), _c('div', {
    staticClass: "cbmh"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_ack_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('div', {
    staticClass: "cbmh",
    attrs: {
      "id": "toc-discover-page"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/discoverpage"
    }
  }, [_vm._v("Discover More")])]), _vm._v(" "), _c('div', {
    staticClass: "cbmh"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_nts_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NOTES")])]), _vm._v(" "), _c('div', {
    staticClass: "cbmh"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_in1_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("INDEX")])]), _vm._v(" "), _c('div', {
    staticClass: "cbmh"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/clau_9780738214993_oeb_cop_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright Page")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30f94514","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/clau_9780738214993_oeb_toc_r1.vue
// module id = 63
// module chunks = 0